import { TooltipGridCell, TooltipGridRow } from "@infobis/ui-styles-utils";
import cn from "classnames";
import st from '../baseChartTooltipWithHeader.module.scss';
import stBase from '../../baseTooltipStyles.module.scss';

interface NdviHeaderProps { title?: string }
const NdviHeader = ({ title }: NdviHeaderProps) => {
    return (
        <TooltipGridRow>
            <TooltipGridCell contentClassName={cn(stBase['cell-content'], st['text--bold'] )}>
                <span className={stBase['text--ellipsis']}>{title}</span>
            </TooltipGridCell>
            <TooltipGridCell />
        </TooltipGridRow>
    )
}

interface WorksHeaderProps { dateStart: string, dateEnd: string, differenceInDays: string }
const WorksHeader = ({ dateStart, dateEnd, differenceInDays }: WorksHeaderProps) => {
    return (
        <TooltipGridRow>
            <TooltipGridCell contentClassName={cn(stBase['cell-content'], st['text--bold'] )}>
                {dateStart} - {dateEnd}
            </TooltipGridCell>
            <TooltipGridCell
                contentClassName={st['text--blue']}
                align={'end'}
            >
                {differenceInDays}
            </TooltipGridCell>
        </TooltipGridRow>
    )
}

interface PhasesHeaderProps { title?: string, dateStart: string, dateEnd: string }
const PhasesHeader = ({ title, dateEnd, dateStart }: PhasesHeaderProps) => {
    return (
        <TooltipGridRow>
            <TooltipGridCell contentClassName={cn(stBase['cell-content'], st['text--blue'] )}>
                <span className={stBase['text--ellipsis']}>{title}</span>
            </TooltipGridCell>
            <TooltipGridCell
                contentClassName={st['text--bold']}
                align={'end'}
            >
                {dateStart} - {dateEnd}
            </TooltipGridCell>
        </TooltipGridRow>
    )
}

export { PhasesHeader, WorksHeader, NdviHeader }